/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementQuickStackIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementQuickStackIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 2C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3L2.89746 13.9951C2.39333 13.9438 2 13.5177 2 13V3C2 2.44772 2.44772 2 3 2H13ZM3 8.5V13H7.5V8.5H3ZM8.5 8.5V13H13V8.5H8.5ZM3 7.5H7.5V3H3V7.5ZM8.5 7.5H13V3H8.5V7.5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementQuickStackIcon.tags = [
  'quick stack',
  'stack',
  'grid',
  'layout',
  'panel',
  'window',
  'menu',
];

ElementQuickStackIcon.category = 'Navigator';

ElementQuickStackIcon.iconSize = 16;
